export default "__VITE_ASSET__Dt$q7c2q__"